import graphQLClient from '../../../helpers/graphQLClient';
import { STRIPE_CHECKOUT_LINK } from '../../../helpers/graphql/stripe';
import Button from '@mui/material/Button';
import PlanPickerOption from './PlanPickerOption';
import { useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from 'next/link';

export default function PlanPicker({ blogId }) {
  const [selected, setSelected] = useState('pro');
  const [isMonthly, setIsMonthly] = useState(false);
  const [checkoutClicked, setCheckoutClicked] = useState(false);

  const getCheckoutLink = () => {
    setCheckoutClicked(true);
    graphQLClient(STRIPE_CHECKOUT_LINK, {
      plan: selected,
      isMonthly,
      blogId,
    })
      .then(res => {
        //   Redirect to checkout link
        if (res && res.stripeCheckoutLink) {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          if (isIOS) {
            window.open(res.stripeCheckoutLink, '_blank');
          } else {
            window.location.href = res.stripeCheckoutLink;
          }
        }
        setCheckoutClicked(false);
        // else: TODO: Show error snackbar
      })
      .catch(err => {
        console.log(err);
        setCheckoutClicked(false);
        // TODO: Show error snackbar
      });
  };

  const plans = [
    {
      title: 'basic',
      pricing: { monthly: 19, yearly: 15 },
      features: 'Use your own domain • Basic widgets',
    },
    {
      title: 'pro',
      pricing: { monthly: 29, yearly: 25 },
      features: 'All features from BASIC + Pro Widgets + Search + Dark Mode',
      isHighlighted: true,
    },
    {
      title: 'vip',
      pricing: { monthly: 49, yearly: 45 },
      features: 'All features from PRO + Api Access + Dedicated Support',
    },
  ];

  return (
    <>
      <div className="tw-mx-auto">
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          align="center"
          className="tw-font-semibold"
        >
          Choose your Plan
        </Typography>
        <FormGroup>
          <Typography component="div" className="tw-m-auto">
            <Grid
              component="label"
              container
              alignItems="center"
              spacing={1}
              className="tw-cursor-pointer"
            >
              <Grid item>Monthly</Grid>
              <Grid item>
                <Switch
                  checked={!isMonthly}
                  onChange={() => setIsMonthly(!isMonthly)}
                  name="checkedA"
                  color="primary"
                />
              </Grid>
              <Grid item>Yearly (save up to 21%)</Grid>
            </Grid>
          </Typography>
        </FormGroup>

        <div className="tw-mt-6 tw-space-y-8 xl:tw-mt-12">
          {plans.map(plan => (
            <PlanPickerOption
              key={plan.title}
              plan={plan}
              setSelected={setSelected}
              selected={selected}
              isMonthly={isMonthly}
            />
          ))}

          <div className="tw-flex tw-justify-center">
            <Button
              color="primary"
              variant="contained"
              onClick={getCheckoutLink}
              disabled={checkoutClicked}
              size="large"
            >
              Choose Plan
            </Button>
          </div>
        </div>
        <div className="text-center postcontent">
          <Typography
            component="p"
            variant="body2"
            gutterBottom
            className="tw-mt-5"
          >
            Undecided?{' '}
            <Link href="/join#pricing">View detailed comparison</Link>
          </Typography>
        </div>
      </div>
    </>
  );
}
